import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';
import { withRouter } from 'react-router-dom';
import { DEVICE, LIBRARY_ASSETS_ORIGIN_URL } from '@/constants';
import {
  report, userShare,
  scorm, booksTrack,
  statistic,
} from '@/api';
import { callNativeFunction, nativeFunction, OS } from '@/utils/detectDevice';
import Work from '@/components/Work';
import Recording from '@/components/Recording/index';
import Report from '@/components/Report';
import RiseError from '@/components/RiseError';
import NativeAudioButton from '@/components/NativeAudioButton';
import close from '@/assets/images/share/close-m-o@3x.png';
import WorkTitle from '@/assets/images/share/work_title.png';
import WorkActive from '@/assets/images/share/work_active.png';
import RecordingTitle from '@/assets/images/share/recording_title.png';
import RecordingActive from '@/assets/images/share/recording_active.png';
import ReportTitle from '@/assets/images/share/report_title.png';
import ReportActive from '@/assets/images/share/report_active.png';
import Thumb from '@/assets/images/share/share.png';
import './style.less';

const shareType = [
  'work',
  'audio',
  'diamonds',
];

const components = {
  [shareType[0]]: {
    type: 1,
    component: Work,
    url: 'share_work',
    shareTitle: '贺卡分享查看',
  },
  [shareType[1]]: {
    type: 2,
    component: Recording,
    url: 'share_recording',
    shareTitle: '语音分享查看',
  },
  [shareType[2]]: {
    type: 3,
    component: Report,
    url: 'share_report',
    shareTitle: '报告分享查看',
  },
};

const tapRef = React.createRef();
const audioRef = React.createRef();
let recordTxt = '';
let recordAudioSrc = '';
let wordAudioSrc = '';
const Share = ({ history, match }) => {
  const { params } = match;
  const host = `${LIBRARY_ASSETS_ORIGIN_URL}resource/`;
  const stageId = params.stageId.split('-')[0];
  const audioUrl = `${host}audio/`;
  const [audioSrc, setAudioSrc] = useState('');
  const [imgSrc, setImgSrc] = useState('');
  const [tapName, setTapName] = useState(shareType[0]);
  const [reportData, setReportData] = useState(null);
  const [shareBtn, setShareBtn] = useState(true);
  const [soundUrl, setSoundUrl] = useState('');
  const [herderPlayDis, setHerderPlayDis] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [shareUrl, setShareUrl] = useState('');
  const [recordError, setRecordError] = useState({ show: false, txt: '您尚未录音' });
  const [QRCodeShow, setQRCodeShow] = useState(false);

  const init = (shareData) => {
    setImgSrc(`${host}img/reachout/${shareData[0].share_source[0].image_name}`);
    recordTxt = shareData[0].share_source[0].introduce_word;
    recordAudioSrc = `${audioUrl}${shareData[0].share_source[0].instruction_audio}`;
    wordAudioSrc = `${audioUrl}${shareData[0].share_source[1].instruction_audio}`;
    setAudioSrc(wordAudioSrc);
  };

  const getData = async () => {
    const shareData = await scorm.list({ ...params, stageId });
    init(shareData.data);
  };

  useEffect(() => {
    getData();
    window.onfire.on('endPlayMyRecordingUI', () => {
      tapRef.current.endPlay && tapRef.current.endPlay();
    });
    window.onfire.on('shareEnd', () => {
      setShareBtn(true);
    });
    window.onfire.on('endedPlay', () => {
      tapRef.current.endPlay && tapRef.current.endPlay();
    });
    return () => {
      window.onfire.off('shareEnd');
      window.onfire.off('endedPlay');
      window.onfire.off('endPlayMyRecordingUI');
    };
  }, []);

  const audioEnd = () => setPlaying(false);

  const audioStop = () => {
    audioRef.current.stop();
    setPlaying(false);
  };

  const audioPlay = () => {
    audioRef.current.play();
    setPlaying(true);
  };

  const getReport = async () => {
    const data = await report.list(params.id, params.attempt);
    setReportData(data.data);
  };

  useEffect(() => {
    setAudioSrc(tapName === 'audio' ? recordAudioSrc : wordAudioSrc);
    tapName === 'diamonds' && getReport();
    setQRCodeShow(false);
    setHerderPlayDis(false);
    audioStop();
  }, [tapName]);

  const replaceStatusName = (keyName, hashTable) => hashTable[keyName];

  const postAddUserShare = async (type) => {
    const shareData = replaceStatusName(tapName, components);
    const data = shareData.type === 1 ? tapRef.current.getValue() : null;
    const result = await userShare.post({
      sid: parseInt(params.id, 10),
      attempt: parseInt(params.attempt, 10),
      type: shareData.type,
      w_from: data ? data.from : '',
      w_to: data ? data.to : '',
      w_con: data ? data.content : '',
      a_con: soundUrl,
      s_diamonds: shareData.type === 3 ? JSON.stringify(reportData).replace(new RegExp('"', 'g'), '\\"') : '',
    });
    if (result.code === 200) {
      await booksTrack.post({
        scormid: parseInt(params.id, 10),
        scoid: 0,
        element: 'cmi.core.share.type',
        value: shareData.type,
        attempt: parseInt(params.attempt, 10),
      });
      const url = `${window.location.origin}/${shareData.url}/${params.id}/${result.data.data[0].id}/${params.attempt}`;
      if (OS.TYPE === DEVICE.PC) {
        setQRCodeShow(true);
        setShareBtn(true);
        setShareUrl(url);
      } else {
        callNativeFunction(nativeFunction.TO_SHARE)({
          url,
          title: shareData.shareTitle,
          description: url,
          thumb: `${window.location.protocol}${Thumb}`,
          type,
        });
      }
      statistic.post({ share: 1 });
    }
  };

  const handleShare = (type) => {
    if ((soundUrl && tapName === 'audio') || tapName !== 'audio') {
      setShareBtn(false);
      postAddUserShare(type);
    } else {
      setRecordError({ show: true, txt: '您尚未录音' });
    }
    statistic.post({ share: 1 });
  };

  const handleClose = () => {
    audioStop();
    history.push(`/stage/${params.stage}/${stageId}`);
  };

  const handlePlay = () => {
    playing ? audioStop() : audioPlay();
  };

  const callBack = url => setSoundUrl(url);

  const renderShareType = () => {
    const ComponentName = replaceStatusName(tapName, components).component;
    return (
      <ComponentName
        ref={tapRef}
        data={tapName === 'diamonds' ? reportData : null}
        recordTxt={recordTxt}
        callback={callBack}
        btnDis={playing}
        headerPlayDis={() => setHerderPlayDis(true)}
      />
    );
  };

  return (
    <div className={`share-container ${tapName}`}>
      <div className={`share ${tapName}`}>
        <div className="header">
          <img src={close} alt="" onClick={handleClose} />
        </div>
        <ul className="tap">
          <li className={tapName === 'work' ? 'active' : ''} onClick={() => setTapName('work')}>
            <img className="work" src={tapName === 'work' ? WorkActive : WorkTitle} alt="" />
          </li>
          <li className={tapName === 'audio' ? 'active' : ''} onClick={() => setTapName('audio')}>
            <img className="audio" src={tapName === 'audio' ? RecordingActive : RecordingTitle} alt="" />
          </li>
          <li className={tapName === 'diamonds' ? 'active' : ''} onClick={() => setTapName('diamonds')}>
            <img className="diamonds" src={tapName === 'diamonds' ? ReportActive : ReportTitle} alt="" />
          </li>
        </ul>
        <div className="share-wrapper">
          <div className="share-wrapper-header" style={{ display: tapName === 'work' || tapName === 'audio' ? 'block' : 'none' }}>
            <div className="share-wrapper-header-diamond" />
            <div className="share-wrapper-header-txt">Reach Out</div>
            <div className={`share-wrapper-header-play${playing ? ' playing' : ''}`} onClick={!herderPlayDis ? handlePlay : undefined} />
          </div>
          {renderShareType()}
          <div className={`share-pic ${tapName}`} style={{ display: tapName === 'work' || tapName === 'audio' ? 'block' : 'none' }}>
            <img src={imgSrc} alt="" />
          </div>
          <div className={`share-btn ${tapName}`}>
            <div className="moments" onClick={shareBtn ? () => handleShare('WEIXIN_CIRCLE') : undefined} />
            <div className="friend" onClick={shareBtn ? () => handleShare('WEIXIN') : undefined} />
          </div>
        </div>
      </div>
      {recordError.show && tapName === 'audio'
        ? <RiseError txt={recordError.txt} hide={() => setRecordError({ show: false, txt: '' })} />
        : null
      }
      <NativeAudioButton src={audioSrc} audioEnd={audioEnd} playData={{ type: 'share' }} ref={audioRef} changeBtnStatus={() => {}} />
      { QRCodeShow ? <div className="qr-code"><QRCode size={150} value={shareUrl} /></div> : null }
    </div>
  );
};

Share.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object,
};

export default withRouter(Share);
